<script lang="ts">
  import { createClientStore } from '$lib/stores/createClientStore';

  const request = createClientStore.request;
</script>

<form id="initialUserForm" class="grid h-full w-1/2 grid-cols-1 gap-5 border border-surface-500 p-5 rounded-container-token">
  <label class="label">
    <span>Initial Username/Email *</span>
    <input class="input" type="text" bind:value={$request.initialUserDetails.username} required />
  </label>
  <label class="label">
    <span>Password *</span>
    <input class="input" type="text" bind:value={$request.initialUserDetails.password} required />
  </label>
  <label class="label">
    <span>Name *</span>
    <input class="input" type="text" bind:value={$request.initialUserDetails.name} required />
  </label>
</form>
